<template>
  {{ fullname }}
  <q-avatar
    :key="localInitials"
    :size="size"
    font-size="10px"
    text-color="white"
    :style="getAvatarStyle()"
  >
    {{ localInitials }}
  </q-avatar>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { Employee } from "@/models/employees";

defineOptions({ name: "IstAvatar" });

const props = withDefaults(
  defineProps<{
    fullname?: string;
    initials?: string;
    employee?: Employee | null;
    size?: string;
    color?: string;
  }>(),
  {
    fullname: "",
    initials: "",
    employee: null,
    size: "32px",
    color: ""
  }
);

const localFullname = ref<string>("");
const localInitials = ref<string>("");

const getInitials = (name: string): string => {
  const trimmed = (name || "").trim();
  const nameParts = trimmed.split(" ");
  if (nameParts.length === 1) {
    return nameParts[0].substring(0, 2).toUpperCase();
  }
  const lastIndex = nameParts.length - 1;
  const firstName = nameParts[0];
  const lastName = nameParts[lastIndex];
  return firstName.substring(0, 1).toUpperCase() + lastName.substring(0, 1).toUpperCase();
};

const getAvatarStyle = () => {

  return {
    "background-color": props.color,
    float: "left"
  } as Record<string, string>;
};

onMounted(() => {
  if (props.employee) {
    localFullname.value = props.employee.first_name + " " + props.employee.last_name;
  }
  if (!props.initials || props.initials.length === 0) {
    localInitials.value = getInitials(localFullname.value);
  } else {
    localInitials.value = props.initials;
  }
});

watch(
  () => props.fullname,
  (newValue, oldValue) => {
    if (oldValue !== newValue) {
      localFullname.value = newValue || "";
      localInitials.value = getInitials(localFullname.value);
    }
  }
);
</script>

<style></style>
